import axios from 'axios';

// The shared site password (no accounts). Once entered it is remembered in
// this browser and sent with every FastAPI request as X-Access-Password.
// It unlocks the B+ signal page and the full news archive.
export const ACCESS_HEADER = 'X-Access-Password';
const STORAGE_KEY = 'site.accessPassword';

export const getAccessPassword = () => {
    try {
        return window.localStorage.getItem(STORAGE_KEY) || '';
    } catch (e) {
        return '';
    }
};

export const setAccessPassword = (password) => {
    try {
        if (password) window.localStorage.setItem(STORAGE_KEY, password);
        else window.localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        // Storage blocked (private mode): the password just isn't remembered.
    }
};

// Asks the server whether a password is right, without remembering it.
export const checkAccessPassword = async (password) => {
    const response = await axios.get('/api/access/check', { headers: { [ACCESS_HEADER]: password } });
    return Boolean(response.data && response.data.ok);
};
